//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  -- List books ----------------
export const getAudioCheckerInit = () => ({ type: ActionTypes.audioChecker.getAudioCheckerInit });
export const setAudioChecker = (returnedPayload) => ({ type: ActionTypes.audioChecker.setAudioChecker, payload: returnedPayload });

//  -- List All books ----------------
